import { TicketItem } from 'shared/models/ticket.ts'

export interface TariffInfoState {
  isError?: boolean
  isLoading?: boolean
  tickets?: TicketItem[]
}

export const shouldShowTariffSkeleton = ({
  hasFareFamily,
  tariffInfo,
  shouldLoadTariff,
}: {
  hasFareFamily: boolean
  tariffInfo: TariffInfoState | null
  shouldLoadTariff: boolean
}) =>
  hasFareFamily &&
  !tariffInfo?.isError &&
  (Boolean(tariffInfo?.isLoading) ||
    (!tariffInfo?.tickets?.length && (!tariffInfo || !shouldLoadTariff)))
